module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"title":"Não foi possível validar este recebedor","description":"Você pode tentar outra vez dentro de alguns meses."},"en-US":{"title":"The recipient could not be validated","description":"You can try again in a few months."}}')
  delete Component.options._Ctor
}
